module.exports = __webpack_public_path__ + "static/media/scheduled-billing.b538d4de.svg";